import { message } from 'antd';
import { useEffect, useState } from 'react';
import { getExamsSignature } from '../../../services/exam';

const useExamSignature = (type) => {
  const [loadingServices, setLoadingServices] = useState(false);
  const [data, setData] = useState([]);
  const [params, setParams] = useState({});
  const [pagination, setPagination] = useState({});
  const [counts, setCounts] = useState({});
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    if (!Object.keys(params).length) return;

    const fetchServices = async () => {
      try {
        setLoadingServices(true);
        const response = await getExamsSignature(
          { 
            ...params,
            type,
            page: currentPage, 
          }
        );
        
        if (response) {
          setData([ ...response['data'] ]);
          setPagination(response['pagination']);
          if (response['counts']) {
            setCounts(response['counts']);
          }
        }
        
        setLoadingServices(false);
      } catch (error) {
        console.error(error);
        message.error({
          content: `Error al traer datos: ${error}`,
          style: {
            marginTop: '40vh',
          },
        });
        setLoadingServices(false);
      }
    };
    
    fetchServices();
  }, [params, currentPage, type]);

  return {
    data,
    setParams,
    currentPage,
    setCurrentPage,
    loadingServices,
    pagination,
    counts,
  };
};

export default useExamSignature;
